module.exports = __webpack_public_path__ + "static/media/Azure_Configuration_Serra_Labs.ebff13ed.pdf";